import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/arrow-right.svg")